import { render, staticRenderFns } from "./NextLink.vue?vue&type=template&id=2a7df300&lang=html&"
import script from "./NextLink.vue?vue&type=script&lang=js&"
export * from "./NextLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports